import { MultiAutocomplete } from 'Components/UI/Atoms/CustomAutocomplete'

const NO_APLICA_OPTION = {
  id: 'NO_APLICA',
  nombre: 'No aplica',
}

const getVehicleTypeConfig = (concept) => {
  return (
    concept?.vehicleTypeConfig || {
      mode: 'NO_APLICA',
      vehicleTypeIds: [],
    }
  )
}

const getSelectedVehicleTypes = (concept, vehicleTypes) => {
  const vehicleTypeConfig = getVehicleTypeConfig(concept)

  if (!vehicleTypeConfig || vehicleTypeConfig.mode === 'NO_APLICA') {
    return [NO_APLICA_OPTION]
  }

  return (vehicleTypes || []).filter((type) => vehicleTypeConfig.vehicleTypeIds?.includes(type.id))
}

const buildVehicleTypeConfig = (value) => {
  const selectedOptions = value || []
  const selectedVehicleTypes = selectedOptions.filter((option) => option.id !== NO_APLICA_OPTION.id)
  const lastSelected = selectedOptions[selectedOptions.length - 1]

  if (selectedOptions.length === 0 || lastSelected?.id === NO_APLICA_OPTION.id) {
    return {
      mode: 'NO_APLICA',
      vehicleTypeIds: [],
    }
  }

  return {
    mode: 'POR_TIPO_VEHICULO',
    vehicleTypeIds: selectedVehicleTypes.map((type) => type.id),
  }
}

export const Settings = (concept, edit, setSelectedConcept, constants, vehicleTypes = []) => {
  const selectedVehicleTypes = getSelectedVehicleTypes(concept, vehicleTypes)
  const hasVehicleTypes = selectedVehicleTypes.some((type) => type.id !== NO_APLICA_OPTION.id)
  const vehicleTypeOptions = [NO_APLICA_OPTION, ...(vehicleTypes || [])]

  return [
    {
      class: 'custom',
      component: (
        <MultiAutocomplete
          name="vehicleTypeConfig"
          options={vehicleTypeOptions}
          getOptionLabel={(e) => e.nombre}
          getOptionDisabled={(option) => {
            return option.id === NO_APLICA_OPTION.id && hasVehicleTypes
          }}
          value={selectedVehicleTypes}
          label="Tipo de vehículo"
          onChange={(_, value) => {
            setSelectedConcept({
              ...concept,
              vehicleTypeConfig: buildVehicleTypeConfig(value),
            })
          }}
          tagName="nombre"
          heightInput="auto"
          disabled={!edit || vehicleTypeOptions.length <= 1}
          noOptionsText="No hay tipos de vehículo disponibles"
        />
      ),
      sm: 12,
      xs: 12,
    },
    {
      class: 'custom',
      component: (
        <MultiAutocomplete
          name="puertas"
          options={constants.puertas || []}
          getOptionLabel={(e) => e.tipo}
          value={(constants?.puertas || []).filter((p) => concept?.puertas?.includes(p.value))}
          label="Puertas"
          onChange={(_, value) => {
            setSelectedConcept({
              ...concept,
              puertas: value.map((v) => v.value),
            })
          }}
          tagName="tipo"
          heightInput="auto"
          disabled={!edit}
        />
      ),
      sm: 6,
      xs: 12,
    },
    {
      class: 'custom',
      component: (
        <MultiAutocomplete
          name="traccion"
          options={constants.tracciones || []}
          getOptionLabel={(e) => e.tipo}
          value={(constants?.tracciones || []).filter((p) => concept?.traccion?.includes(p.value))}
          label="Tracción"
          onChange={(_, value) => {
            setSelectedConcept({
              ...concept,
              traccion: value.map((v) => v.value),
            })
          }}
          tagName="tipo"
          heightInput="auto"
          disabled={!edit}
        />
      ),
      sm: 6,
      xs: 12,
    },
    {
      class: 'custom',
      component: (
        <MultiAutocomplete
          name="combustible"
          options={constants.combustibles}
          getOptionLabel={(e) => e.tipo}
          value={(constants?.combustibles || []).filter((p) =>
            concept?.combustible?.includes(p.value)
          )}
          label="Combustible"
          onChange={(_, value) => {
            setSelectedConcept({
              ...concept,
              combustible: value.map((v) => v.value),
            })
          }}
          tagName="tipo"
          heightInput="auto"
          disabled={!edit}
        />
      ),
      sm: 6,
      xs: 12,
    },
    {
      class: 'custom',
      component: (
        <MultiAutocomplete
          name="turbo"
          options={constants.turbos}
          getOptionLabel={(e) => e.tipo}
          value={(constants?.turbos || []).filter((p) => concept?.turbo?.includes(p.value))}
          label="Turbo"
          onChange={(_, value) => {
            setSelectedConcept({
              ...concept,
              turbo: value.map((v) => v.value),
            })
          }}
          tagName="tipo"
          heightInput="auto"
          disabled={!edit}
        />
      ),
      sm: 6,
      xs: 12,
    },
    {
      class: 'autocomplete',
      sm: 12,
      xs: 12,
      options: constants?.transmisiones || [],
      name: 'transmision',
      label: 'Transmisión',
      optionLabel: `options["tipo"]`,
      optionValue: 'value',
      value: concept?.transmision,
      defaultValue: constants?.transmisiones.find((v) => v.value === concept?.transmision),
      disabled: !edit,
      onChange: (e) => {
        setSelectedConcept({
          ...concept,
          transmision: e ? e.value : null,
        })
      },
    },
  ]
}
